import React from "react";
import classes from "../../ARC_Reconciliation/Sales/GST-1_Reconciliation/GSTReconciliation.module.css";


const CreditLedgerTable = ({ data }) => {
    const formatCurrency = (value) => value ? `₹${value.toLocaleString("en-IN")}` : "-";

    return (
        <div
            className="responsive-table"
            style={{ scrollbarWidth: "thin", scrollbarHeight: '25px', maxHeight: '63vh' }}
        >
            <table className={classes.AllInvoiceReconTableCss}>
                <thead>
                    <tr>
                        <th rowSpan={2} style={{width:'3%'}}>Tax Period</th>
                        <th rowSpan={2} style={{width:'3%'}}>Date</th>
                        <th rowSpan={2} style={{width:'6%'}}>Reference No</th>
                        {[
                            "Opening Balance (Cr)", "ITC accrued through - Inputs (Cr) (Input for the Month)", 
                            "Other than reverse charge (Dr) (Input Utilized for the Month)", "Closing Balance (Cr)"].map((taxType) => (
                            <th  colSpan={5} key={taxType} align="center">{taxType} Amount Debited / Credited</th>
                        ))}
                    </tr>
                    <tr>
                        {[...Array(4)].map((_, i) => (
                            ["Integrated Tax", "Central Tax", "State Tax", "Cess", "Total"].map((header) => (
                                <th key={i + header}>{header}</th>
                            ))
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data && data.length > 0 ? (
                        data.map((row, index) => (
                            <tr key={index} style={{height:'45px'}}>
                                <td>{row['Tax Period'] || "-"}</td>
                                <td>{row['Date'] || "-"}</td>
                                <td>{row['Reference No'] || "-"}</td>

                                <td>{formatCurrency(row['Opening Balance (Cr)']['Integrated Tax']) || "-"}</td>
                                <td>{formatCurrency(row['Opening Balance (Cr)']['Central Tax']) || "-"}</td>
                                <td>{formatCurrency(row['Opening Balance (Cr)']['State Tax']) || "-"}</td>
                                <td>{formatCurrency(row['Opening Balance (Cr)']['Cess']) || "-"}</td>
                                <td>{formatCurrency(row['Opening Balance (Cr)']['Total']) || "-"}</td>

                                <td>{formatCurrency(row['ITC accrued through - Inputs (Cr) (Input for the Month)']['Integrated Tax']) || "-"}</td>
                                <td>{formatCurrency(row['ITC accrued through - Inputs (Cr) (Input for the Month)']['Central Tax']) || "-"}</td>
                                <td>{formatCurrency(row['ITC accrued through - Inputs (Cr) (Input for the Month)']['State Tax']) || "-"}</td>
                                <td>{formatCurrency(row['ITC accrued through - Inputs (Cr) (Input for the Month)']['Cess']) || "-"}</td>
                                <td>{formatCurrency(row['ITC accrued through - Inputs (Cr) (Input for the Month)']['Total']) || "-"}</td>

                                <td>{formatCurrency(row['Other than reverse charge (Dr) (Input Utilized for the Month)']['Integrated Tax']) || "-"}</td>
                                <td>{formatCurrency(row['Other than reverse charge (Dr) (Input Utilized for the Month)']['Central Tax']) || "-"}</td>
                                <td>{formatCurrency(row['Other than reverse charge (Dr) (Input Utilized for the Month)']['State Tax']) || "-"}</td>
                                <td>{formatCurrency(row['Other than reverse charge (Dr) (Input Utilized for the Month)']['Cess']) || "-"}</td>
                                <td>{formatCurrency(row['Other than reverse charge (Dr) (Input Utilized for the Month)']['Total']) || "-"}</td>

                                <td>{formatCurrency(row['Closing Balance (Cr)']['Integrated Tax']) || "-"}</td>
                                <td>{formatCurrency(row['Closing Balance (Cr)']['Central Tax']) || "-"}</td>
                                <td>{formatCurrency(row['Closing Balance (Cr)']['State Tax']) || "-"}</td>
                                <td>{formatCurrency(row['Closing Balance (Cr)']['Cess']) || "-"}</td>
                                <td>{formatCurrency(row['Closing Balance (Cr)']['Total']) || "-"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={8} style={{ textAlign: "center", fontWeight: "bold" }}>Loading… Please wait</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default CreditLedgerTable;
